import {TableContainer, TableHead, TableBody, TableCell, TableRow, Paper, Table, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_SPEC, TAB_TAX_SUMS} from './StatsCommon.js';
import StatsFilter from './StatsFilter.js';
import {getSpecName} from '../Trans.js'
import {COMM_OK} from '../WsR2.js';

const CSO_N_OBS		= 0;
const CSO_N_IND		= 1;
const CSO_N_CITIES	= 2;
const CSO_SPEC		= 3;
const CSO_IND_PER_OBS	= 4;
const CSO_N_YEARS	= 5;
const CSO_N_DATES	= 6;

const CSD_DESC		= 0;
const CSD_ASC		= 1;

const StatsTaxons = observer((props) => {
	let cnt_sum, num_sum, n_cities_sum, ind_per_obs_sum, n_years_sum, n_dates_sum;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function taxonsYearChange(event) {
		gStorage.stats.setStatsYear(event.target.value);
		gStorage.stats.setObsList(null);
	}

	function statsTaxonsGetSpecName(id) {
		return getSpecName(gStorage.lists.speclist.list.find(elem => elem.id === id), gStorage.conn.user);
	}

	function taxonsRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('taxonsRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('taxonsSumRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_SPEC || gStorage.stats.spec_tab !== TAB_TAX_SUMS)
			return;

// 		console.log('taxonsRxWs', msg);
		gStorage.stats.setObsList(msg.data.taxons);
	}

	function taxonsCountLoad() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'counts',
			data: {
				country: gStorage.stats.country.id,
				year: gStorage.stats.statsYear,
				user: {
					id: /*gStorage.stats.allUsers ? 0 : */gStorage.conn.user.id,
				},
			}
		}
// 		console.log('taxonsCountLoad', msg);
		gStorage.conn.ws.send(msg, taxonsRxWs);
	}

	/* ------------------------------------------------------------------ */

	function taxonSignSpecName() {
		if (gStorage.stats.taxon_sort_order !== CSO_SPEC)
			return '';

		return gStorage.stats.taxon_sort_dir === CSD_DESC ? ' ↓' : ' ↑' ;
	}

	function taxonSignNumObs() {
		if (gStorage.stats.taxon_sort_order !== CSO_N_OBS)
			return '';

		return gStorage.stats.taxon_sort_dir === CSD_DESC ? ' ↓' : ' ↑' ;
	}

	function taxonSignNumInd() {
		if (gStorage.stats.taxon_sort_order !== CSO_N_IND)
			return '';

		return gStorage.stats.taxon_sort_dir === CSD_DESC ? ' ↓' : ' ↑' ;
	}

	function taxonSignNumCities() {
		if (gStorage.stats.taxon_sort_order !== CSO_N_CITIES)
			return '';

		return gStorage.stats.taxon_sort_dir === CSD_DESC ? ' ↓' : ' ↑' ;
	}

	function taxonSignIndPerObs() {
		if (gStorage.stats.taxon_sort_order !== CSO_IND_PER_OBS)
			return '';

		return gStorage.stats.taxon_sort_dir === CSD_DESC ? ' ↓' : ' ↑' ;
	}

	function taxonSignNumYears() {
		if (gStorage.stats.taxon_sort_order !== CSO_N_YEARS)
			return '';

		return gStorage.stats.taxon_sort_dir === CSD_DESC ? ' ↓' : ' ↑' ;
	}

	function taxonSignNumDates() {
		if (gStorage.stats.taxon_sort_order !== CSO_N_DATES)
			return '';

		return gStorage.stats.taxon_sort_dir === CSD_DESC ? ' ↓' : ' ↑' ;
	}

	/* ------------------------------------------------------------------ */

	function tglSortDir() {
		return gStorage.stats.taxon_sort_dir === CSD_DESC ? CSD_ASC : CSD_DESC;
	}

	function sortByNobs(p1, p2) {
		if (gStorage.stats.taxon_sort_dir === CSD_ASC)
			return p1.cnt - p2.cnt;

		return p2.cnt - p1.cnt;
	}

	function sortByNInd(p1, p2) {
		if (gStorage.stats.taxon_sort_dir === CSD_ASC)
			return p1.num - p2.num;

		return p2.num - p1.num;
	}

	function sortByNumberOfCities(p1, p2) {
		if (gStorage.stats.taxon_sort_dir === CSD_ASC)
			return p1.n_cities - p2.n_cities;

		return p2.n_cities - p1.n_cities;
	}

	function sortBySpecName(p1, p2) {
		if (gStorage.stats.taxon_sort_dir === CSD_ASC)
			return statsTaxonsGetSpecName(p1.spec_id).localeCompare(statsTaxonsGetSpecName(p2.spec_id), 'fi');

		return statsTaxonsGetSpecName(p2.spec_id).localeCompare(statsTaxonsGetSpecName(p1.spec_id), 'fi');
	}

	function sortByIndPerObs(p1, p2) {
		const p1_num_per_obs = p1.num / p1.cnt;
		const p2_num_per_obs = p2.num / p2.cnt;

		if (gStorage.stats.taxon_sort_dir === CSD_ASC)
			return p1_num_per_obs - p2_num_per_obs;

		return p2_num_per_obs - p1_num_per_obs;
	}

	function sortByNumberOfYears(p1, p2) {
		if (gStorage.stats.taxon_sort_dir === CSD_ASC)
			return p1.n_years - p2.n_years;

		return p2.n_years - p1.n_years;
	}

	function sortByNumberOfDates(p1, p2) {
		if (gStorage.stats.taxon_sort_dir === CSD_ASC)
			return p1.n_dates - p2.n_dates;

		return p2.n_dates - p1.n_dates;
	}

	function taxonStatsSortResults(list) {
		// console.log('cityStatsSortResults', gStorage.stats.taxon_sort_order, gStorage.stats.taxon_sort_dir);

		switch (gStorage.stats.taxon_sort_order) {
		case CSO_N_OBS:
			return list.toSorted(sortByNobs);
		case CSO_N_IND:
			return list.toSorted(sortByNInd);
		case CSO_N_CITIES:
			return list.toSorted(sortByNumberOfCities);
		case CSO_SPEC:
			return list.toSorted(sortBySpecName);
		case CSO_IND_PER_OBS:
			return list.toSorted(sortByIndPerObs);
		case CSO_N_YEARS:
			return list.toSorted(sortByNumberOfYears);
		case CSO_N_DATES:
			return list.toSorted(sortByNumberOfDates);
		default:
			console.error('Invalid taxon stats sorting order', 
				gStorage.stats.taxon_sort_order);
			break;
		}

		return null;
	}

	/* ------------------------------------------------------------------ */

	function setSortBySpecName() {
		if (gStorage.stats.taxon_sort_order === CSO_SPEC) {
			gStorage.stats.setTaxonOrder(CSO_SPEC, tglSortDir());
		} else {
			gStorage.stats.setTaxonOrder(CSO_SPEC, CSD_ASC);
		}

		gStorage.stats.setObsList(taxonStatsSortResults(gStorage.stats.obsList));
	}

	function setSortByNumObs() {
		if (gStorage.stats.taxon_sort_order === CSO_N_OBS) {
			gStorage.stats.setTaxonOrder(CSO_N_OBS, tglSortDir());
		} else {
			gStorage.stats.setTaxonOrder(CSO_N_OBS, CSD_DESC);
		}

		gStorage.stats.setObsList(taxonStatsSortResults(gStorage.stats.obsList));
	}

	function setSortByNumInd() {
		if (gStorage.stats.taxon_sort_order === CSO_N_IND) {
			gStorage.stats.setTaxonOrder(CSO_N_IND, tglSortDir());
		} else {
			gStorage.stats.setTaxonOrder(CSO_N_IND, CSD_DESC);
		}

		gStorage.stats.setObsList(taxonStatsSortResults(gStorage.stats.obsList));		
	}

	function setSortByNumCities() {
		if (gStorage.stats.taxon_sort_order === CSO_N_CITIES) {
			gStorage.stats.setTaxonOrder(CSO_N_CITIES, tglSortDir());
		} else {
			gStorage.stats.setTaxonOrder(CSO_N_CITIES, CSD_DESC);
		}

		gStorage.stats.setObsList(taxonStatsSortResults(gStorage.stats.obsList));		
	}

	function setSortByIndPerObs() {
		if (gStorage.stats.taxon_sort_order === CSO_IND_PER_OBS) {
			gStorage.stats.setTaxonOrder(CSO_IND_PER_OBS, tglSortDir());
		} else {
			gStorage.stats.setTaxonOrder(CSO_IND_PER_OBS, CSD_DESC);
		}

		gStorage.stats.setObsList(taxonStatsSortResults(gStorage.stats.obsList));		
	}

	function setSortByNumYears() {
		if (gStorage.stats.taxon_sort_order === CSO_N_YEARS) {
			gStorage.stats.setTaxonOrder(CSO_N_YEARS, tglSortDir());
		} else {
			gStorage.stats.setTaxonOrder(CSO_N_YEARS, CSD_DESC);
		}

		gStorage.stats.setObsList(taxonStatsSortResults(gStorage.stats.obsList));		
	}

	function setSortByNumDates() {
		if (gStorage.stats.taxon_sort_order === CSO_N_DATES) {
			gStorage.stats.setTaxonOrder(CSO_N_DATES, tglSortDir());
		} else {
			gStorage.stats.setTaxonOrder(CSO_N_DATES, CSD_DESC);
		}

		gStorage.stats.setObsList(taxonStatsSortResults(gStorage.stats.obsList));		
	}

	/* ------------------------------------------------------------------ */

	if (gStorage.stats.tab !== TAB_SPEC || gStorage.stats.spec_tab !== TAB_TAX_SUMS)
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online) {
		taxonsCountLoad();
		gStorage.stats.setTaxonOrder(CSO_N_OBS, CSD_DESC);
	}

	cnt_sum = 0;
	num_sum = 0;
	n_cities_sum = 0;
	ind_per_obs_sum = 0;
	n_years_sum = 0;
	n_dates_sum = 0;

	return (
		<>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<StatsFilter 
						loc = {{country: {
								value: gStorage.stats.country,
								style: {width: 200}
							}
						}}
						time = {{
							year: {
								year: gStorage.stats.statsYear,
								onChange: taxonsYearChange,
								enabled: gStorage.conn.online,
								allowNone: true
							}
						}}
					/>
				</Grid>
			</Grid>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell align='center' padding='checkbox'>#</TableCell>
							<TableCell align='left'   padding='checkbox' sx={{cursor: 'pointer'}} onClick={setSortBySpecName}>{t('taxons.taxon') + taxonSignSpecName()}</TableCell>
							<TableCell align='right'  padding='checkbox' sx={{cursor: 'pointer'}} onClick={setSortByNumObs}>{t('taxons.count2') + taxonSignNumObs()}</TableCell>
							<TableCell align='right'  padding='checkbox' sx={{cursor: 'pointer'}} onClick={setSortByNumInd}>{t('taxons.num2') + taxonSignNumInd()}</TableCell>
							<TableCell align='right'  padding='checkbox' sx={{cursor: 'pointer'}} onClick={setSortByIndPerObs}>{t('taxons.ind_per_obs') + taxonSignIndPerObs()}</TableCell>
							<TableCell align='right'  padding='checkbox' sx={{cursor: 'pointer'}} onClick={setSortByNumCities}>{t('taxons.cities') + taxonSignNumCities()}</TableCell>
							<TableCell align='right'  padding='checkbox' sx={{cursor: 'pointer'}} onClick={setSortByNumYears}>{t('stats.years') + taxonSignNumYears()}</TableCell>
							<TableCell align='right'  padding='checkbox' sx={{cursor: 'pointer'}} onClick={setSortByNumDates}>{t('stats._dates') + taxonSignNumDates()}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{gStorage.stats.obsList && gStorage.stats.obsList.map((m, i) => {
							const ind_per_obs = (m.num / m.cnt);

							cnt_sum += m.cnt;
							num_sum += m.num;
							n_cities_sum += m.n_cities;
							ind_per_obs_sum += ind_per_obs;
							n_years_sum += m.n_years;
							n_dates_sum += m.n_dates;

							return (<TableRow key={i}>
									<TableCell align='center' padding='checkbox'>{i + 1}</TableCell>
									<TableCell align='left'                     >{statsTaxonsGetSpecName(m.spec_id)}</TableCell>
									<TableCell align='right'  padding='checkbox'>{m.cnt}</TableCell>
									<TableCell align='right'  padding='checkbox'>{m.num}</TableCell>
									<TableCell align='right'  padding='checkbox'>{ind_per_obs.toFixed(2)}</TableCell>
									<TableCell align='right'  padding='checkbox'>{m.n_cities}</TableCell>
									<TableCell align='right'  padding='checkbox'>{m.n_years}</TableCell>
									<TableCell align='right'  padding='checkbox'>{m.n_dates}</TableCell>
								</TableRow>);
						})}

						{gStorage.stats.obsList && gStorage.stats.obsList.length ? 
							<TableRow key={gStorage.stats.obsList.length + 1}>
								<TableCell align='center' padding='checkbox'></TableCell>
								<TableCell />
								<TableCell style={{fontWeight: 'bold'}} align='right'>{cnt_sum}</TableCell>
								<TableCell style={{fontWeight: 'bold'}} align='right'>{num_sum}</TableCell>
								<TableCell style={{fontWeight: 'bold'}} align='right'>{(ind_per_obs_sum / gStorage.stats.obsList.length).toFixed(2)}</TableCell>
								<TableCell style={{fontWeight: 'bold'}} align='right'>{n_cities_sum}</TableCell>
								<TableCell style={{fontWeight: 'bold'}} align='right'>{n_years_sum}</TableCell>
								<TableCell style={{fontWeight: 'bold'}} align='right'>{n_dates_sum}</TableCell>
							</TableRow> :
							null
						}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
});

export default StatsTaxons;
